import PropTypes from 'prop-types';

import {copyableProperty} from '../common';

/**
 * Display value for 1 st level category
 */
export const firstLevelCategory = (event) => copyableProperty(
    {
        data: event,
        nonSr: ['content_category', 'parent', 'parent'],
    },
    'Content category'
);

firstLevelCategory.propTypes = {
    event: PropTypes.object.isRequired,
};
